const faqs = [
  {
    title: "3Chat.ai 是什么，与普通 AI 客服有什么不同？",
    content:
      "3Chat.ai 是成交导向的 AI 销冠智能体。普通 AI 客服更关注问题是否被回答，3Chat 更关注对话是否被推进到企业定义的业务结果，例如留资、预约、销售接手、下单或复购。",
  },
  {
    title: "哪类企业最适合使用 3Chat.ai？",
    content:
      "拥有大量客户资产，或持续获取高成本、高价值线索的 B2C 企业最适合使用。尤其适用于对话量大、销售流程相对明确、业务结果可验证的场景。",
  },
  {
    title: "3Chat 可以推进哪些成交结果？",
    content:
      "企业可以根据业务定义目标，包括再次开口、有效激活、复购、增购、留资、预约、到店、试用、报价、销售接手、下单与成交。",
  },
  {
    title: "Builder 如何生成并测试企业专属 Agent？",
    content:
      "商家通过自然语言提供业务目标、产品知识、销售 SOP、话术和转人工条件。Builder 生成初始 Agent 后，可在沙盒中测试并校准，再由商家决定何时上线。",
  },
  {
    title: "Evaluation 如何发现流失原因并优化 Agent？",
    content:
      "Evaluation 将客户对话、业务上下文、Agent 动作与最终结果放在一起复盘，识别知识缺口、错误判断、错失机会和转人工时机，并将建议送回 Builder 确认。",
  },
  {
    title: "Agent 何时转人工，人工接手后如何协同？",
    content:
      "转人工条件由企业根据业务风险、客户阶段和销售策略配置。触发后，销售可直接在工作台接入，也可以根据客户留下的联系方式主动跟进。",
  },
  {
    title: "3Chat 能连接哪些渠道和业务系统？",
    content:
      "3Chat 可连接客户沟通渠道，并通过原生能力、API、Webhook 或 MCP 对接 CRM、订单、库存、预约等业务系统。具体支持范围以渠道与集成清单为准。",
  },
  {
    title: "如何开始试用与上线？",
    content:
      "注册后即可开始 15 天免费试用。你可以先在 Builder 中生成首版 Agent，在沙盒完成测试和校准，再根据实际业务场景连接渠道并上线。",
  },
];

export default faqs;
